export default {"src":"/_next/static/media/ODT.9f3de3a3.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};